import UIStore from './uiStore';
import * as constants from '../appConstants';
// import axios from 'axios';
import opsMapData from '../assets/data/ops-map.json';
import canadaDealerLocations from '../assets/data/canada-dealers.json';

class RootStore {
    constructor() {
        this.opsMapCountryData = opsMapData.stateListView;
        this.opsMapCountries = sanitizeData(opsMapData.stateListView);
        this.uiStore = new UIStore();
        // this.requestDealerLocations();
    }

    // requestDealerLocations = () => {
    //     // api currently only supports US dealers
    //     const countries = [constants.UNITED_STATES];
    //     // have to do separate calls for both toyota and lexus dealers
    //     const brands = [constants.BRAND_TOYOTA, constants.BRAND_LEXUS];
    //     countries.forEach(country => {
    //         brands.forEach(brand => {
    //             this.getDealerLocations(brand, country);
    //         });
    //     });
    // }

    /**
     * Call to Dealer Locator to get dealer coordinates by brand
     */
    // getDealerLocations = (brand, country) => {
    //     // brandId is handled by an integer for each toyota brand
    //     // Toyota: 1, Lexus: 2, Scion: 3
    //     // only toggling between 1 and 2 since scion dealers are not required
    //     const brandId = (brand === constants.BRAND_LEXUS) ? 2 : 1;
    //     const instance = axios.create();
    //     const requestParams = {
    //         brandId: brandId,
    //         resultsFormat: 'json',
    //         searchMode: 'pma'
    //     }
    //     instance.defaults.headers.get['x-api-key'] = constants.DL_API_KEY;
    //     instance.get(constants.DL_API_URI, {
    //             params: requestParams
    //         })
    //         .then(response => {
    //             const fetchedDealersArray = response.data.showDealerLocatorDataArea.dealerLocator[0].dealerLocatorDetail;
    //             const groupedDealers = groupDealersByState(fetchedDealersArray);
    //             this.processDealers(groupedDealers, country, brand);
    //         })
    //         .catch(error => {
    //             console.log('DEALER RESPONSE ERROR:', error);
    //             return [];
    //         });
    // }

    // processDealers = (dealers, country, brand) => {
    //     for (const state in this.opsMapCountries[country]) {
    //         const stateAbr = state.slice(-2);
    //         if (dealers.hasOwnProperty(stateAbr)) {
    //             this.opsMapCountries[country][state][`${brand}Dealers`] = dealers[stateAbr];
    //         }
    //     }
    // }
}

function sanitizeData(data) {
    const countries = [constants.UNITED_STATES, constants.CANADA, constants.MEXICO];
    const sanitizedData = {};
    countries.forEach(country => {
        sanitizedData[country] = sanitizeCountry(data[country]);
    });
    return sanitizedData;
}

function sanitizeCountry(country) {
    return Object.keys(country).reduce((countryObj, stateKey) => {
        countryObj[`${country[stateKey].country}${country[stateKey].abbreviation}`] = sanitizeState(country[stateKey]);
        return countryObj;
    }, {});
}

function sanitizeState(state) {
    const gid = `${state.country}${state.abbreviation}`,
        corporateOffices = parseInt(state.corporateOffices, 10),
        manufacturingDistribution = parseInt(state.manufacturingDistribution, 10),
        researchDesign = parseInt(state.researchDesign, 10);

    let dealers = parseInt(state.dealers, 10);
    const dealersCoordinates = [];
    let hasDetails = !!corporateOffices || !!dealers || !!manufacturingDistribution || !!researchDesign;

    if (state.country === 'CA' && canadaDealerLocations[state.abbreviation]) {
        const stateDealerArray = canadaDealerLocations[state.abbreviation];
        dealers = stateDealerArray.length;
        stateDealerArray.forEach(dealer => {
            dealersCoordinates.push(dealer.coordinates);
        });
        if (dealers > 0) {
            hasDetails = true;
        }
    }

    return {
        abbreviation: state.abbreviation,
        classList: state.classList,
        coordinates: JSON.parse(constants.DOT_OVERRIDES[gid] || state.coordinates),
        corporateOffices,
        country: state.country,
        dealers,
        dealersCoordinates,
        gid,
        hasDetails,
        imgSrc: `/images/states/${state.country}/${gid}.svg`,
        manufacturingDistribution,
        researchDesign,
        score: Number(state.score),
        showAnimation: state.showAnimation,
        state: state.state,
        tallyList: state.tallyList,
    };
}


// function sanitizeDealerLocation(dealer) {
//     const coordinates = dealer.proximityMeasureGroup.geographicalCoordinate;
//     return {
//         name: dealer.dealerParty.specifiedOrganization.companyName.value,
//         latitude: coordinates ? coordinates.latitudeMeasure.value : '',
//         longitude: coordinates ? coordinates.longitudeMeasure.value : '',
//     }
// }

// function groupDealersByState(data) {
//     // `data` is an array of objects
//     // reduce runs this anonymous function on each element of `data` (the `item` parameter)
//     // returning the `storage` parameter at the end
//     return data.reduce(function(storage, item) {
//         // Get the first instance of the key (state) by which we're grouping
//         // To get the state value we have to dig down into a few sub-properties of the dealer object
//         var group = item.dealerParty.specifiedOrganization.postalAddress.stateOrProvinceCountrySubDivisionID.value;
//         storage[group] = storage[group] || [];
//         storage[group].push(sanitizeDealerLocation(item));

//         // return the updated storage to the reduce function, which will then loop through the next
//         return storage;
//     }, {});
// };

export default RootStore;
